import type {
  DeprovisionFundManagerClientRequest,
  OrganizationInfo,
  CompanyInfo,
} from "../../../api/clientsManagementTypes";
import { definedValidator } from "@entrilia/shared/utilities/validators";
import type { FormValidationResults } from "../../../utilities/forms";

export interface FundManagerDeprovisioningForm {
  organization: OrganizationInfo | null;
  client: CompanyInfo | null;
  deleteClientData: boolean;
  deleteOtherData: boolean;
  validationResults: FormValidationResults<ValidationKey>;
}

type ValidationKey = "organization" | "client";

export const getInitialFundManagerDeprovisioningForm = (): FundManagerDeprovisioningForm => ({
  organization: null,
  client: null,
  deleteClientData: true,
  deleteOtherData: true,
  validationResults: {},
});

export const validateFundManagerDeprovisioningForm = (
  form: FundManagerDeprovisioningForm
): FormValidationResults<ValidationKey> => {
  return {
    organization: definedValidator("Organization is required")(form.organization),
    client: definedValidator("Client is required")(form.client),
  };
};

export const mapFundManagerDeprovisioningFormToRequest = (
  form: FundManagerDeprovisioningForm
): DeprovisionFundManagerClientRequest => ({
  clientCode: form.client?.clientCode ?? "",
  deleteContacts: form.deleteClientData,
  deleteInvestors: form.deleteClientData,
  deleteFunds: form.deleteClientData,
  deleteOtherData: form.deleteOtherData,
});
